
export declare type Language = "de" | "en";

export interface IUserInfo {
	nickname: string;
	locale: "de" | "en";
	orig: number;
	admin?: boolean;
	avatar?: string;
}

export const LsfParameters = {
	RegEditStart: new Date(2023, 11, 22, 18).getTime(),
	RegAddStart: new Date(2024, 0, 1, 18).getTime(),
	ShirtEditEnd: new Date(2024, 4, 1).getTime(),
	SponsorEditEnd: new Date(2024, 4, 1).getTime(),
};
